import moment, { type Moment } from 'moment';
import { any } from 'ramda';

import { toMoment } from 'utils/dateUtils';

export const createEmailSubjectLine = ({
  firstName,
  lastName,
  businessName,
}: {
  firstName: string;
  lastName: string;
  businessName: string;
}) =>
  `${firstName} ${lastName} from ${businessName} wants to collaborate in Paperless Parts`;

export const findFarthestExpiration = (
  expirationDates: (string | null)[],
): Moment | null => {
  if (any((expirationDate) => expirationDate === null)(expirationDates)) {
    return null;
  }

  const moments = expirationDates.map((dateString) =>
    toMoment(dateString as string),
  );
  return moment.max(moments);
};
